export enum LoadingState {
  IDLE,
  CREATE,
  READ,
  UPDATE,
  DELETE,
  ARCHIVE,
}